import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { ProfileService } from '../profile.service';
import { GeneralService } from '../../../shared/services/general.service';
import { User } from 'aws-sdk/clients/iam';
import { Params, Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-profile-dialog',
  templateUrl: './edit-profile-dialog.component.html',
  styleUrls: ['./edit-profile-dialog.component.scss']
})
export class EditProfileDialogComponent implements OnInit {
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  menu = [];
  user: User;
  hasType: boolean;
  isSelf: boolean;
  constructor(
    public dialogRef: MatDialogRef<EditProfileDialogComponent>,
    private route: ActivatedRoute,
     private router: Router,
    private profileService: ProfileService,
    private generalService: GeneralService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.user = data.user;
      this.isSelf = data.isSelf;
    }

  ngOnInit(): void {
    this.loadMenus();
  }

  onCloseDialog() {
      this.router.navigate(['/profile']);
      this.dialogRef.close();
  }

  closeEvent(event) {
    if (event) {
      this.action.emit(true);
      this.onCloseDialog();
    }
  }

  loadMenus() {
    this.menu.push('PROFILE');
    this.menu.push('HOUSE PERMISSIONS');
      if (this.isSelf) {
        this.menu.push('PASSWORD');
      }
  }

  changeTab(event) {
    this.hasType = event;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/edit-profile-dialog/edit-profile-dialog.component.ts